import Sidebar from '@components/sidebar';
import Topbar from '@components/topbar';
import KycPage from '@pages/kyc';
import ProviderOnboarding from '@pages/provider-onboarding';
import { Loader, StatusBox } from '@ui';
import React from 'react';
import { LayoutSC } from './dashboard-layout.styled';
import { useUserDashboardState } from './dashboard-layout.utils';
import { FormattedMessage } from 'react-intl';

type TLayoutProps = {
  children: React.ReactNode;
};

const Layout: React.FC<TLayoutProps> = ({ children }: TLayoutProps) => {
  const [userState] = useUserDashboardState();

  if (userState === null) {
    return (
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}
      >
        <Loader variant="on-light" size="large" loading />
      </div>
    );
  }

  if (userState === 'error') {
    return (
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}
      >
        <StatusBox
          type="failed"
          title={'Hilbi'}
          description={<FormattedMessage id="provider.onboarding.form.error" />}
        />
      </div>
    );
  }

  // Wait for KYC
  if (userState === 'kyc') {
    return <KycPage />;
  }

  /**
   * Wait for provider setup/onboarding
   */
  if (userState === 'provider') {
    return <ProviderOnboarding />;
  }

  // Render dashboard
  return (
    <LayoutSC>
      <Sidebar />
      <Topbar showProviders authorized />
      {children}
    </LayoutSC>
  );
};

export default Layout;
